import React, { Component, ComponentType } from 'react';

// info - interfejs, o który powinny być rozszerzane propsy komponentu komponowanego z poniższym HOC
export interface WithTableClickableModalsHandlerProps {
  /** akcja otwierająca modal */
  openModal: (modalName: string) => void;
  /** akcja zamykająca modal */
  closeModal: () => void;
  /** informacje o otwartych modalach */
  openedModals: string[];
}

interface State {
  /** przechowuje informacje, który klikalny modal jest otwarty na zakładce korzystającej z tabeli */
  openedModals: string[];
}

type ComponentProps = object;
export type TableClickableModalsHandler = ComponentProps;

/**
 * HOC dla widoków obsługujących klikalne modale występujące w parze z tabelą (boxy filtrów, modal wyboru kolumn do wyświetlenia w tabeli).
 * Dostarcza akcje zarządzające otwieraniem / zamykaniem boxów oraz informacje o aktualnie otwartym modalu.
 * Jest zaprojektowany tak, aby w jednym momencie pozwalał na trzymanie w stanie otwarcia tylko jednego boxa.
 *
 * @param Cmp
 */
function withTableClickableModalsHandler<P extends ComponentProps>(Cmp: ComponentType<P>) {
  class Controller extends Component<TableClickableModalsHandler, State> {
    constructor(props: TableClickableModalsHandler) {
      super(props);
      this.state = {
        openedModals: [],
      } as State;
    }
    /**
     * openModal - akcja otwierająca box.
     * Pozwala na otwarcie jednego boxa w jednym momencie.
     *
     * @param {string} modalName
     * @memberof Controller
     */
    openModal = (modalName: string): void => {
      this.setState(prev => ({ ...prev, openedModals: [modalName] }));
    };
    /**
     * closeModal - Funkcja zamykająca boxy.
     *
     * @memberof Controller
     */
    closeModal = (): void => {
      this.setState(prev => ({ ...prev, openedModals: [] }));
    };
    render(): React.ReactNode {
      return (
        <Cmp
          {...(this.props as P)}
          openedModals={this.state.openedModals}
          openModal={this.openModal}
          closeModal={this.closeModal}
        />
      );
    }
  }
  return Controller;
}

export default withTableClickableModalsHandler;
